import axios, { AxiosResponse } from 'axios';
import {
  AuthUserParams,
  ConfirmRegistrationParams,
  ResetPasswordParams,
  SetAuthUserTypeParams,
  SetUserOrfAffiliationParams,
} from 'types/aaaService';
import { gql } from '@apollo/client';

// GraphQL Requests
export const GET_ORG_AFFILIATION = gql`
  query AAA_SERVICE_getOrgAffiliationV2 {
    getOrgAffiliationV2
  }
`;

export const GET_AUTH_USER_TYPES = gql`
  query AAA_SERVICE_getAuthUserTypes {
    getAuthUserTypes
  }
`;

// Axios Requests

export const setUserOrgAffiliation = async (params: SetUserOrfAffiliationParams): Promise<AxiosResponse<string>> => {
  const res = await axios.post(`https://${process.env.REACT_APP_API_BASE_URL}/aaa/Prod/setUserOrgAffiliation`, params, {
    withCredentials: true,
  });
  return res;
};

export const setAuthUserType = async (params: SetAuthUserTypeParams): Promise<AxiosResponse<string>> => {
  const res = await axios.post(`https://${process.env.REACT_APP_API_BASE_URL}/aaa/Prod/setAuthUserType`, params, {
    withCredentials: true,
  });
  return res;
};

export const authUser = async (params: AuthUserParams): Promise<AxiosResponse<string>> => {
  const res = await axios.post(`https://${process.env.REACT_APP_API_BASE_URL}/aaa/Prod/authUser`, params, {
    withCredentials: true,
  });
  return res;
};

export const forgotPasswordRequest = async (params: { email: string }): Promise<AxiosResponse<string>> => {
  const res = await axios.post(`https://${process.env.REACT_APP_API_BASE_URL}/aaa/Prod/forgotPassword`, params);
  return res;
};

export const confirmRegistrationRequest = async (params: ConfirmRegistrationParams): Promise<AxiosResponse<string>> => {
  const res = await axios.post(`https://${process.env.REACT_APP_API_BASE_URL}/aaa/Prod/confirmRegistration`, params, {
    withCredentials: true,
  });
  return res;
};

export const resetPasswordRequest = async (params: ResetPasswordParams): Promise<AxiosResponse<string>> => {
  const res = await axios.post(`https://${process.env.REACT_APP_API_BASE_URL}/aaa/Prod/resetPassword`, params);
  return res;
};

export const logoutUserRequest = async (): Promise<void> => {
  await axios.post(`https://${process.env.REACT_APP_API_BASE_URL}/aaa/Prod/logOut`, {}, { withCredentials: true });
};
